function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useContext } from 'react';
import styles from './TabList.module.scss';
import cs from 'classnames';
import Tab from '../Tab/Tab';
import ThemeContext from '../../ThemeContext/ThemeContext';
export default function TabList(_ref) {
  var compact = _ref.compact,
    align = _ref.align,
    tabs = _ref.tabs;
  var theme = useContext(ThemeContext);
  if (tabs.length) {
    return /*#__PURE__*/React.createElement("ul", {
      role: "tablist",
      className: cs(styles.list, "".concat(styles[theme]), "".concat(styles[align]), _defineProperty({}, styles.compact, compact))
    }, tabs.map(function (tab) {
      return /*#__PURE__*/React.createElement(Tab, {
        key: tab.id,
        id: tab.id,
        i18n: tab.i18n
      });
    }));
  } else {
    return null;
  }
}